import * as React from 'react';

function SvgCalendars(props) {
  return (
    <svg width="3em" height="3em" viewBox="0 0 32.014 28.128" {...props}>
      <g data-name="Group 5576" fill="#eea804">
        <path data-name="Rectangle 4089" d="M.999 6.183h30.013v2.001H.999z" />
        <path data-name="Rectangle 4090" d="M6.009 12.041h3.95v1.997h-3.95z" />
        <path data-name="Rectangle 4091" d="M22.008 11.997h3.962v1.997h-3.962z" />
        <path data-name="Rectangle 4092" d="M14.004 12.041h4.002v1.997h-4.002z" />
        <path data-name="Rectangle 4093" d="M24.009 0h2.001v3.834h-2.001z" />
        <path data-name="Rectangle 4094" d="M15.001.08h2.001v3.834h-2.001z" />
        <path data-name="Rectangle 4095" d="M5.997.08h2.001v3.834H5.997z" />
        <path data-name="Rectangle 4096" d="M19.591 1.953h1.997v2.001h-1.997z" />
        <path data-name="Rectangle 4097" d="M10.647 1.953h2.001v2.001h-2.001z" />
        <path data-name="Path 4107" d="M27.968 1.949v2h2.045v22.178H1.999V3.95h2v-2h-4v26.18h32.014V1.949z" />
        <path data-name="Rectangle 4098" d="M6.009 16.039h3.95v1.997h-3.95z" />
        <path data-name="Rectangle 4099" d="M6.045 20.013h3.958v2.001H6.045z" />
        <path data-name="Rectangle 4100" d="M22 20.005h4.022v2.001H22z" />
        <path data-name="Rectangle 4101" d="M14 20.013h4.006v2.001H14z" />
        <path data-name="Rectangle 4102" d="M14.004 16.039h4.002v1.997h-4.002z" />
        <path data-name="Rectangle 4103" d="M22 16.007h4.006v2.001H22z" />
      </g>
    </svg>
  );
}

export default SvgCalendars;
